module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f07500_banner_800x600.ce7e2bc6.png";